(function () {

  'use strict';

  angular.module('SoftwareProvider', [])

    .constant('ApplicationType', {
      CLIENT: 'CLIENT',
      REDIRECTOR: 'REDIRECTOR',
      CONFIGURATOR: 'CONFIGURATOR'
    })

    .constant('OperatingSystem', {
      MAC: 'MAC',
      WIN: 'WIN'
    })

    .constant('FileType', {
      DMG: 'DMG',
      EXE: 'EXE',
      MSI: 'MSI',
      PKG: 'PKG',
      ZIP: 'ZIP'
    })

    .constant('CpuArchitecture', {
      X64: 'x64',
      ARM64: 'arm64'
    })

    .service('SoftwareService', function ($http, $q, TenantListService) {

      this.getConfiguredSoftwareVersion = function (applicationType, operatingSystem, cpuArchitecture, fileType) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:software'].href;
        const params = { appl: applicationType, os: operatingSystem, cpuArch: cpuArchitecture, type: fileType };
        $http.get(url, { params })
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (response) {
            deferred.reject(response.data);
          });
        return deferred.promise;
      };

      this.buildDesktopApplicationDownloadUrl = function (applicationType, operatingSystem, cpuArchitecture, fileType, version) {
        let url = TenantListService.currentTenant.info._links['px:software'].href +
          '/appl/' + applicationType + '/os/' + operatingSystem + '/type/' + fileType;
        const queryParams = [];
        if (cpuArchitecture) {
          queryParams.push('cpuArch=' + cpuArchitecture);
        }
        if (version) {
          queryParams.push('version=' + version);
        }
        if (queryParams.length) {
          url += '?' + queryParams.join('&');
        }
        return url;
      };

    });

})();
